module.exports = __webpack_public_path__ + "img/intro_no.4ce62c59.svg";